import { Amplify } from 'aws-amplify';

const appOrigin = window.location.origin;
const redirectSignIn = [`${appOrigin}`];
const redirectSignOut = [`${appOrigin}/signin`];

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn,
          redirectSignOut,
          responseType: 'code',
          providers: ['Google'],
        },
        email: true
      }, // enables email/password sign-in
    }
  }
});
